import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function TruthSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-404">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-16 bg-gold/30" data-id="element-405"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-406">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-407">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-10" data-id="element-408">
            {t('truth', 'title')}
          </h2>

          <div className="space-y-8 text-lg text-dark/80" data-id="element-409">
            <p data-id="element-410">{t('truth', 'loseMoney')}</p>
            <p className="text-2xl font-serif text-gold-dark font-medium" data-id="element-411">
              {t('truth', 'loseConfidence')}
            </p>
            <p data-id="element-412">{t('truth', 'believe')}</p>
            <p className="italic" data-id="element-413">{t('truth', 'accept')}</p>
            <div className="py-6" data-id="element-414">
              <p className="text-2xl font-bold text-dark uppercase tracking-wider" data-id="element-415">
                {t('truth', 'lie')}
              </p>
            </div>
            <p className="font-medium" data-id="element-416">{t('truth', 'soldLie')}</p>
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-px h-16 bg-gold/30" data-id="element-417"></div>
    </section>;
}